import { useDrawingArea } from "@mui/x-charts";

const ChartColorSwitch = () => {
  const { top, height, bottom } = useDrawingArea();
  const svgHeight = top + bottom + height;

  return (
    <>
      <defs>
        <linearGradient
          id="paint0_linear_45_2"
          x1="300.25"
          y1="46.9999"
          x2="300.25"
          y2={`${svgHeight}px`}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8b58f1" stopOpacity="0.2" />
          <stop offset="1" stopColor="#8b58f1" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint0_linear_45_3"
          x1="299.498"
          y1="-4.28272"
          x2="299.498"
          y2={`${svgHeight}px`}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B519EC" stopOpacity="0.4" />
          <stop offset="1" stopColor="#B519EC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </>
  );
};

export default ChartColorSwitch;
